// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"Overlay-Overlay-overlayWrapper-c617acd3"};